import styled from "styled-components"

import laptop from "../../../../assets/laptop.png"
import { devices } from "../../../../themes/theme"
import { Box } from "../../../elements/Box"
import { ButtonLink } from "../../../elements/ButtonLink"

const LINKS = [
  {
    key: "trial",
    url: "https://jp.josys.com/contact/free",
    text: "無料で使ってみる",
  },
  {
    key: "resources",
    url: "https://jp.josys.com/contact/resources",
    text: "資料ダウンロード",
  },
]

const imageHeight = "15.5rem"
const Container = styled.section`
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.boxBackground};
  position: relative;
  margin-block-start: calc(
    ${imageHeight} / 2 + clamp(0rem, -2rem + 10vw, 10rem)
  );

  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(5rem, 3rem + 10vw, 15rem) clamp(1rem, 0rem + 5vw, 6rem)
    clamp(1.5rem, 0.5rem + 5vw, 6.5rem);
  background-color: ${(props) => props.theme.colors.boxBackground};
`

const Image = styled.img`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;

  @media ${devices.tablet} {
    width: 40%;
  }
`

const LinksContainer = styled(Box)`
  margin-block-start: 2.5rem;
  padding-block-end: 1.5rem;
  row-gap: 2rem;

  @media ${devices.mobile} {
    padding-block-end: 0;
  }
`

const Span = styled.span`
  font-weight: 500;
  font-size: clamp(0.75rem, 0.675rem + 0.375vw, 1.125rem);
  line-height: 180%;
  letter-spacing: 0.05em;
`

const PRSection = () => {
  return (
    <Container>
      <Image src={laptop} alt="laptop" />
      <Span>
        情報システム部門のアナログ業務を自動化し、業務コスト削減とセキュリティレベル向上を支えるITデバイスとSaaSの統合管理クラウド​
      </Span>
      <LinksContainer flexDirection="row" gapInRem={1} flexWrap="wrap">
        {LINKS.map((link, i) => (
          <ButtonLink
            key={link.key}
            to={link.url}
            $shadow
            $outline={i % 2 === 1}
          >
            {link.text}
          </ButtonLink>
        ))}
      </LinksContainer>
    </Container>
  )
}

export { PRSection }
